import { Component, Input } from '@angular/core';
import { ILotMappedItem } from '@app/logic/lots';
import {
    LOT_CONTRACT_TYPE_ENUM,
    LOT_JOB_STATUS_ENUM,
    LOT_TYPE_ENUM,
    LotTypeEnumId
} from '@classictechsolutions/hubapi-transpiled-enums';
import { buildMigratingHeader } from '../lot-migrator.util';
import { CbDisplayValueModule } from '@app/shared/components/display-value/display-value.module';
import { CbSortByModule } from '@app/shared/pipe/sort-by/sort-by.module';
import { CbTableModule } from 'cb-hub-lib';
import { MatIconModule } from '@angular/material/icon';
import { CbWaitForModule } from '@app/shared/directives/wait-for/wait-for.module';

@Component({
    selector: 'cb-lot-migrator-source-summary',
    standalone: true,
    imports: [CbDisplayValueModule, CbSortByModule, CbTableModule, MatIconModule, CbWaitForModule],
    templateUrl: './lot-migrator-source-summary.component.html',
    styleUrls: ['./lot-migrator-source-summary.component.scss']
})
export class LotMigratorSourceSummaryComponent {
    @Input() public lots: ILotMappedItem[] = [];
    @Input() public lotType: LotTypeEnumId;

    public readonly LOT_TYPE_ENUM = LOT_TYPE_ENUM;
    public readonly LOT_CONTRACT_TYPE_ENUM = LOT_CONTRACT_TYPE_ENUM;
    public readonly LOT_JOB_STATUS_ENUM = LOT_JOB_STATUS_ENUM;

    public getMigratingFromHeader(): string {
        const numberOfLots = this.lots.filter(x => x.lotType !== LotTypeEnumId.Unit).length;
        return buildMigratingHeader({
            prefix: 'Migrating',
            lotType: this.lotType,
            numberOfLots
        });
    }
}
